import axios from "axios";
import { baseUrl } from '../config/clientsConfig'
import { dealStagesData } from "../../Enum";
const DealService ={
    showDealInfo: (taskId)=>{
        return axios.get(`${baseUrl}/deal/${taskId}`);
    },
    dealHistory: (dealId)=>{
        return axios.get(`${baseUrl}/getDealHistoryByDocId?id=${dealId}`)
    },
    sitevisitHistory: (dealId)=>{
        return axios.get(`${baseUrl}/getSiteVisitHistoryByDocId?id=${dealId}`)
    },

    fetchSiteVisit: (teamId)=>{
        if(teamId){
            return axios.get(`${baseUrl}/deals/${dealStagesData["Site Visit"]}${teamId}`)

        }else{
            return axios.get(`${baseUrl}/deals/${dealStagesData["Site Visit"]}`)

        }
    },
    fetchPostVisitFollowUp: (teamId)=>{
        if(teamId){
            return axios.get(`${baseUrl}/deals/${dealStagesData["After Site Visit Follow Up"]}${teamId}`)

        }else{
            return axios.get(`${baseUrl}/deals/${dealStagesData["After Site Visit Follow Up"]}`)

        }
    },
    fetchSitting: (teamId)=>{
        if(teamId){
            return axios.get(`${baseUrl}/deals/${dealStagesData["Sitting"]}${teamId}`)

        }else{
            return axios.get(`${baseUrl}/deals/${dealStagesData["Sitting"]}`)

        }
    },
    fetchPlotBooked: (teamId)=>{
        if(teamId){
            return axios.get(`${baseUrl}/deals/${dealStagesData["Plot Booked"]}${teamId}`)

        }else{

            return axios.get(`${baseUrl}/deals/${dealStagesData["Plot Booked"]}`)
        }
    },
    fetchBookingScheduled: (teamId)=>{
        if(teamId){
        return axios.get(`${baseUrl}/deals/${dealStagesData["After Sitting Follow Up"]}${teamId}`)

        }else{
        return axios.get(`${baseUrl}/deals/${dealStagesData["After Sitting Follow Up"]}`)
        }
    },
    fetchAgreementOngoing: (teamId)=>{
        if(teamId){
        return axios.get(`${baseUrl}/deals/${dealStagesData["Advance Amount Update"]}${teamId}`)

        }else{
        return axios.get(`${baseUrl}/deals/${dealStagesData["Advance Amount Update"]}`)
        }
    },
    fetchRegistrationInProgress: (teamId)=>{
        if(teamId){
        return axios.get(`${baseUrl}/deals/${dealStagesData["Registration InProgress"]}${teamId}`)

        }else{
        return axios.get(`${baseUrl}/deals/${dealStagesData["Registration InProgress"]}`)
        }
    },
    fetchFullyRegistered: (teamId)=>{
        if(teamId){
        return axios.get(`${baseUrl}/deals/${dealStagesData["Fully Registered"]}${teamId}`)

        }else{
        return axios.get(`${baseUrl}/deals/${dealStagesData["Fully Registered"]}`)
        }
    },
    fetchDealLostBeforeBooking: (teamId)=>{
        if(teamId){
        return axios.get(`${baseUrl}/deals/${dealStagesData["Deal Lost Before Booking"]}${teamId}`)

        }else{
        return axios.get(`${baseUrl}/deals/${dealStagesData["Deal Lost Before Booking"]}`)
        }
    },
    fetchDealLostAfterBooking: (StageId,teamId)=>{
        if(teamId){
        return axios.get(`${baseUrl}/deals/${dealStagesData[StageId]}${teamId}`)

        }else{
        return axios.get(`${baseUrl}/deals/${dealStagesData[StageId]}`)
        }
    },
    fetchPipeLineData: (StageId,teamId )=>{
        if(teamId){
        return axios.get(`${baseUrl}/deals/${dealStagesData[StageId]}${teamId}`)

        }else{
        return axios.get(`${baseUrl}/deals/${dealStagesData[StageId]}`)
        }
    },

    fetchPaginationDealData: (StageId, nextId, teamId) =>{

        if(teamId){
            return axios.get(`${baseUrl}/deals/${dealStagesData[StageId]}${teamId}?next=${nextId}&direction=next`)

            }else{
            return axios.get(`${baseUrl}/deals/${dealStagesData[StageId]}?next=${nextId}&direction=next`)
            }
    },
     filterPipeLineData : (stageId, nextId, teamId, propertyId) => {
        let url = `${baseUrl}/deals/filter/${dealStagesData[stageId]}?next=${nextId}&direction=next`;
      
        if (teamId) url += `&teamId=${teamId}`;
        if (propertyId) url += `&propertyId=${propertyId}`;
      
        return axios.get(url);
      }
    
      ,
    fetchDealImages : (dealId)=>{
        return axios.get(`${baseUrl}/dealImages?id=${dealId}`)
    },
    fetchUserDeals : (body)=>{
        return axios.post(`${baseUrl}/deals/userwise`,body)
    },
    updateDealUser : (body)=>{
         return axios.post(`${baseUrl}/deals/update-responsible-person`,body)
         }

}
export default DealService;